import { useLayoutEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const useCloseOnBack = (dialog: string) => {
  const navigate = useNavigate();
  const { search, state } = useLocation();
  const open = state?.dialog === dialog;
  const latestSearch = useRef(search);
  const wasOpen = useRef(open);
  const closing = useRef(false);

  useLayoutEffect(() => {
    if (open) latestSearch.current = search;
    else {
      closing.current = false;
      if (wasOpen.current && search !== latestSearch.current)
        navigate({ search: latestSearch.current }, { replace: true });
    }
    wasOpen.current = open;
  }, [open, search, navigate]);

  const openOnTop = () => navigate({ search }, { state: { dialog } });

  const close = () => {
    if (!open || closing.current) return;
    closing.current = true;
    navigate(-1);
  };

  return { open, openOnTop, close };
};
